import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
// `Authenticated` is the persistent app shell (side nav, notification/message providers) rendered for every
// logged-in route, so it stays statically imported rather than going through `route.lazy`. All actual page
// components below are lazy-loaded per-route (see each route object's `lazy` field) for code splitting.
import Authenticated from '@/app/layouts/AuthenticatedLayout';
import { ROUTES } from '@/shared/config';
import HomeIcon from '@mui/icons-material/Home';
import { createBrowserRouter } from 'react-router-dom';
import { AppRoot } from './AppRoot';
import { authenticatedRoutes } from './authenticated.routes';
import RouteErrorPage from './RouteErrorPage';
import { errorSectionRoutes } from './sections/error';
import { quickUploadSectionRoutes } from './sections/quick-upload';
import type { RoutePathDefinition } from './types';

export const routes: RoutePathDefinition[] = [
  {
    element: <AppRoot />,
    // Catches anything thrown below, including a lazy route whose chunk was removed by a deploy.
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: '/',
        Component: Authenticated,
        handle: {
          crumb: () => (
            <BreadcrumbLink to={ROUTES.HOME}>
              <HomeIcon fontSize={'medium'} />
            </BreadcrumbLink>
          )
        },
        children: authenticatedRoutes
      },
      {
        path: 'login',
        lazy: () => import('@/pages/login').then(m => ({ Component: m.default }))
      },
      {
        path: 'switch-company',
        lazy: () => import('@/pages/switch-company').then(m => ({ Component: m.default }))
      },
      {
        path: 'twofactor-login',
        lazy: () => import('@/pages/login/ui/twoFactorLogin').then(m => ({ Component: m.default }))
      },
      {
        path: 'agreement',
        lazy: () => import('@/pages/agreement').then(m => ({ Component: m.default }))
      },
      {
        path: 'forgot-password',
        lazy: () => import('@/pages/login/ui/forgotPassword').then(m => ({ Component: m.default }))
      },
      {
        path: 'quick-upload/',
        lazy: () => import('@/pages/upload').then(m => ({ Component: m.default })),
        children: quickUploadSectionRoutes
      },
      {
        path: 'error/',
        children: errorSectionRoutes
      }
    ]
  }
];

export const router = createBrowserRouter(routes);
